import React from "react";
import { makeStyles } from "@mui/styles";
import translate from "../../../i18n/translate";
import TotalChartCustomDate from "./totalChartCustomDate";
import { format } from "date-fns";
import { useIntl } from 'react-intl';

const useStyles = makeStyles((theme) => ({
  root: {
    width: "66.66%",
    height: "80%",
    "& p": {
      margin: "0",
      fontFamily: "RobotoRegular",
    },
    [theme.breakpoints.down('md')]: {
      width: "100%",
    },
  },
  alignTop: {
    marginBottom: "3em",
  },
  header: {
    fontSize: "1.3em",
    fontFamily: "RobotoRegular",
    color: theme.palette.primary.main,
    fontWeight: "bold",
  },
  subText: {
    color: "#8993A0",
    fontFamily: "RobotoRegular",
    fontSize: "1em",
    margin: "5px 0 20px 0",
  },
  chart: {
    height: "215px",
    width: "100%",
    marginBottom: '15px',
    [theme.breakpoints.down('md')]: {
      height: "160px",
      width: "100%",
      marginBottom: 20,
    },
  },
}));

const TotalChart = ({
  dateFilter,
  isTotal,
  isLoaded,
  currentWeekSalesData,
  previousWeekSalesData,
}) => {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <div className={classes.root}>
      <div className={classes.alignTop}>
        <p className={classes.header}>{translate("totalChartTitle")}</p>
        <p className={classes.subText}>
          {dateFilter.typ === 1
            ? translate("totalChartSubTitle7")
            : dateFilter.typ === 2
              ? translate("totalChartSubTitle30")
              : localStorage.getItem("userLanguage") === '"tr-TR"'
                ? format(dateFilter.startDate, "dd-MM-yyyy") + " ve " + format(dateFilter.endDate, "dd-MM-yyyy") + intl.formatMessage({ id: "totalChartSubTitleCustomDate" })
                : "Between " + format(dateFilter.startDate, "dd-MM-yyyy") + " and " + format(dateFilter.endDate, "dd-MM-yyyy") + ", total liters served from all Pubinno Smart Taps."}
        </p>
      </div>
      <div className={classes.chart}>
        <TotalChartCustomDate
          previousData={previousWeekSalesData}
          currentData={currentWeekSalesData}
          isLoaded={isLoaded}
          isTotal={isTotal}
          dateFilter={dateFilter}
        />
      </div>
    </div>
  );
};

export default TotalChart;
